export const modalColDefsData = [
  { id: 1, label: '세차기 구분' },
  { id: 2, label: '모델명' },
  { id: 3, label: '세차기 고유번호' },
  { id: 4, label: 'PLC 포트' },
];
